import { render, staticRenderFns } from "./ModalMenus.vue?vue&type=template&id=0cf576d4&scoped=true&"
import script from "./ModalMenus.vue?vue&type=script&lang=js&"
export * from "./ModalMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf576d4",
  null
  
)

export default component.exports